/* auth */
export const SETUSER = 'SETUSER'
export const SETCONSTANTCACHE = 'SETCONSTANTCACHE'
export const SETROLECACHE = 'SETROLECACHE'
export const SETCOOKIE = 'SETCOOKIE'

/* global */
export const SETUSERLOG = 'SETUSERLOG'
export const EXIT = 'EXIT'
export const PUSHHTTP = 'PUSHHTTP'
export const CLEARHTTP = 'CLEARHTTP'
export const SETPAGESTATE = 'SETPAGESTATE'
export const ROLESTATUS = 'ROLESTATUS'
export const ROLEMESSAGECOUNT = 'ROLEMESSAGECOUNT'
export const ROLEMESSAGEDECREASE = 'ROLEMESSAGEDECREASE'
export const ROLEMESSAGEINCREASE = 'ROLEMESSAGEINCREASE'

/* configData */
export const SETCONFIGVERSON = 'SETCONFIGVERSON'
export const SETCONFIGCONSTANTCACHE = 'SETCONFIGCONSTANTCACHE'
/* configmenu */
export const SETCONFIGMENU = 'SETCONFIGMENU'
export const SETMENUVERSON = 'SETMENUVERSON'
export const SETMENURIGHTS = 'SETMENURIGHTS'



// WEBPACK FOOTER //
// ./src/store/type.js